// src/components/CancelOrderButton.tsx

import React, { useState } from 'react';
import { cancelOrder } from '../utils/api'; // Import the function to call the cancel order endpoint
import { useNavigate } from 'react-router-dom';
import { Tables, TableDetails } from '../utils/types'; // Adjust based on your setup
import { updateTableStatus } from '../utils/api';

interface CancelOrderButtonProps {
    orderId: number;
    currentTable: TableDetails | null; // Add the currentTable property
}

const CancelOrderButton: React.FC<CancelOrderButtonProps> = ({ orderId, currentTable }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();
    const [selectedTable, setSelectedTable] = useState<Tables | null>(null);

    const handleCancelOrder = async () => {
        setIsLoading(true);
        setError(null);

        try {
            await cancelOrder(orderId);
            alert('Order canceled successfully.');
            setSelectedTable(null);

            console.log('currentTable', currentTable);
            if (currentTable) {
                await updateTableStatus(
                    Number(currentTable.vendor_id),
                    Number(currentTable.id),
                    'vacant', // Reset table status
                    null, // Remove the orderId
                    null // Remove the customerId
                );
            }

            // navigate('/order-history'); // Or navigate to any other page if necessary
            navigate('/tables');


        } catch (error) {
            setError('An error occurred while canceling the order. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="mx-1 md:mx-5">
            <button onClick={handleCancelOrder} disabled={isLoading} className="CancelBtn w-20">
                {isLoading ? 'Cancelling...' : 'Cancel'}
            </button>
            {error && <p className="text-red-500 mt-2">{error}</p>}
        </div>
    );
};

export default CancelOrderButton;
